mutation ConnectDomain($input: ConnectDomainInput!) {
  connectDomain(input: $input) {
    id
    host
    domainSetup {
      host
      status
      zoneName
      lastError
      updatedAt
      activatedAt
    }
  }
}
